module.exports = __webpack_public_path__ + "img/index-spot.67bf4377.png";